// extracted by mini-css-extract-plugin
module.exports = {"Quote":"Quote-module--Quote--1dzww","Quote__Blockquote":"Quote-module--Quote__Blockquote--2nGPa","Quote__Author":"Quote-module--Quote__Author--eugGM"};